<template>
  <div class="content">
    <div class="title">{{title}}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
    data: () => ({
        title: ''
    }),
 created() {
     console.log(this.$route)
     this.title = this.$route.meta.title
 }
}
</script>

<style lang="scss" scoped>
.content {
    padding: 24px 30px;
    .title {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
    }
}
</style>